import { Outlet } from '@tanstack/react-router';
import { Sidebar } from '@/components/Sidebar';
import { RailResizer, useRailWidth } from '@/components/RailResizer';
import { SupportPill } from '@/components/SupportPill';
import { TopTabs } from '@/components/TopTabs';
import { TrainingPopup } from '@/components/TrainingPopup';
import { ZipImportPanel } from '@/components/ZipImportPanel';
import { ToastHost } from '@/components/Toasts';
import { SelectionProvider } from '@/lib/selection';

export function AppShell() {
  const { width, setWidth } = useRailWidth();

  return (
    // Selection and toasts wrap the whole shell: a bulk move starts in the grid
    // and finishes with a drop on the rail, so both have to see the same state.
    <SelectionProvider>
      <ToastHost>
    <div className="flex h-dvh overflow-hidden surface-page">
      {/* The rail and its handle are hidden together below md — there is no
          room to resize a nav that isn't on screen. */}
      <div className="hidden md:block"><Sidebar width={width} /></div>
      {/* No wrapper div here, deliberately. The resizer's own sizing classes
          (w-[15px], -ml, shrink-0) have to land on the flex child itself; when
          they sat on an inner element inside a plain block wrapper, the wrapper
          became the flex child, collapsed to near-zero width, and clipped the
          handle so it could not be grabbed. It hides itself below md instead. */}
      <RailResizer width={width} onResize={setWidth} />
      <main className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <TopTabs />
        <div className="min-h-0 flex-1 overflow-hidden"><Outlet /></div>
      </main>
      {/* Sits on the shell rather than per-page so it's reachable everywhere behind the auth guard. */}
      <SupportPill />
      <TrainingPopup />
      <ZipImportPanel />
    </div>
      </ToastHost>
    </SelectionProvider>
  );
}
